<app-header
  class="layout-header"
  [menuToggleEnabled]="true"
  (menuToggle)="menuOpened = !menuOpened"
  [title]="appInfo.title"
  [sectionTitle]="pageTitle.current()?.title ?? currentSectionTitle"
  [sectionParent]="pageTitle.current()?.parent ?? currentSectionParent"
  [imageSource]="appInfo.logo"
/>

<div class="layout-with-ai">
  <dx-drawer
    class="layout-body"
    position="before"
    [closeOnOutsideClick]="shaderEnabled"
    [openedStateMode]="menuMode"
    [revealMode]="menuRevealMode"
    [minSize]="minMenuSize"
    [shading]="shaderEnabled"
    [(opened)]="menuOpened"
  >
    <side-navigation-menu
      [compactMode]="!menuOpened"
      [selectedItem]="selectedRoute"
      class="dx-swatch-additional"
      *dxTemplate="let dataMenu of 'panel'"
      (selectedItemChanged)="navigationChanged($event)"
      (openMenu)="navigationClick()"
    >
      <app-footer>
        Copyright &copy; {{ appInfo.currentYear }} <br />
        Crystal
      </app-footer>
    </side-navigation-menu>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </dx-drawer>

  @if (aiPanel.available()) {
    <div class="ai-panel" [class.ai-panel--open]="aiPanel.open()">
      <!-- Loads the panel's chunk (marked, dompurify, chat thread) on first open; stays loaded after. -->
      @defer (when aiPanel.open()) {
        <ai-assistant />
      }
    </div>
  }
</div>

